@if (dashboard()) {
<div class="page-header">
  <div class="page-header__block">
    <div class="page-header__wrapper">
      <ul class="breadcrumb">
        @for (bc of breadcrumbList(); track bc.key; let isFirst = $first) {
        <li class="breadcrumb__item">
          @if (!isFirst) {
          <mat-icon color="primary" class="breadcrumb__separator">chevron_right</mat-icon>
          }
          @if (bc.url) {
          <a [routerLink]="[bc.url]" class="breadcrumb__link">
            {{ bc.title | translate }}
          </a>
          } @else {
          <span class="breadcrumb__link breadcrumb__link--current" aria-current="page">
            {{ bc.title | translate }}
          </span>
          }
        </li>
        }
      </ul>

      @if (alert()) {
      <div class="page-header__alert-container">
        <div class="status-alert" [class]="alertCssClass()">
          <span class="status-alert__message">{{ alert()?.message }}</span>
          <a [href]="alert()?.url" class="status-alert__link">{{ alert()?.linkText }}</a>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}

@if (isComponent()) {
<div class="page-header page-header--component-view">
  <div class="page-header__block">
    <div class="page-header__wrapper">
      <div class="page-header__title">
        @if (breadcrumbList().length) {
        <h2 class="page-header__title-text">
          {{ breadcrumbList()[breadcrumbList().length - 1].title }}
        </h2>
        <a [href]="breadcrumbList()[breadcrumbList().length - 1].url" target="_blank"
          class="page-header__reference-link">
          <mat-icon>open_in_new</mat-icon>
          <span>Referencia</span>
        </a>
        }
      </div>

      @if (alert()) {
      <div class="page-header__alert-container">
        <div class="status-alert" [class]="alertCssClass()">
          <span class="status-alert__message">{{ alert()?.message }}</span>
          <a [href]="alert()?.url" class="status-alert__link">{{ alert()?.linkText }}</a>
        </div>
      </div>
      }
    </div>
  </div>
</div>
}
